var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifier = function SvgMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.2 8.5a5.3 5.3 0 1 1 10.6 0 5.3 5.3 0 0 1-10.6 0m5.3-6.7a6.7 6.7 0 1 0 4.217 11.907l3.795 3.795a.7.7 0 0 0 .99-.99l-3.795-3.795A6.7 6.7 0 0 0 8.5 1.8",
    clipRule: "evenodd"
  })));
};
export default SvgMagnifier;